import { Component, Input } from '@angular/core';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  @Input() footerText: string;

  get footerTextElement(): string {
    return `<p class="text-black font-normal mt-0 text-xs md:text-sm lg:text-base">${this.footerText}</p>`
  }
}
